export const ERROR_MESSAGE = "Đã có lỗi xảy ra. Vui lòng thử lại!";
export const REACT_APP_API = "https://buffer.httv.workers.dev/";
export const SITE_NAME = "bicloud";
export const MANAGEMENT_URL = "https://manage.bicloud.vn";
